import Toastify from 'toastify-js';

const componentData = $('.page-useds .filter .btn');

function getFilterUseds(page) {
    let categoria = $(".page-useds .filter select[name='categoria']").val();
    let concessionaria = $(".page-useds .filter select[name='concessionaria']").val();
    let ordem = $(".page-useds .filter select[name='ordem']").val();

    const obj = {
        categoria,
        concessionaria,
        ordem,
        perPage: 9,
        page,
    };

    return obj;
}

function updateUseds() {
    const url = componentData.data('urlUseds');
    const prevPage = componentData.data('prevPage');
    const nextPage = componentData.data('nextPage');
    const currentPage = componentData.data('currentPage');

    $('.page-useds .nav-page .btn-prev').attr('disabled', !prevPage).toggleClass('opacity-50', !prevPage);
    $('.page-useds .nav-page .btn-prev').attr('href', prevPage ? url + '?' + $.param(getFilterUseds(prevPage)) : '');

    $('.page-useds .nav-page .btn-next').attr('disabled', !nextPage).toggleClass('opacity-50', !nextPage);
    $('.page-useds .nav-page .btn-next').attr('href', nextPage ? url + '?' + $.param(getFilterUseds(nextPage)) : '');

    $('.page-useds .nav-page .num-page').html(currentPage);

    if (!prevPage && !nextPage) {
        $('.page-useds .nav-page').addClass('hidden');
    } else {
        $('.page-useds .nav-page').removeClass('hidden');
    }
}

function getListUseds(page = 1) {
    let self = componentData;
    self.addClass('loading');

    let filters = getFilterUseds(page);

    //animate scroll
    $('html, body').animate({ scrollTop: $('.page-useds .filter').offset().top - $('header').height() - 3 * 16 }, 400);

    $.ajax({
        type: 'GET',
        url: self.data('url'),
        data: filters,
        success: function (data) {
            $('.page-useds .grid').empty();
            $('.page-useds .message').empty();

            if (data.data.length == 0) {
                $('.page-useds .message').html(componentData.data('empty'));
            }

            self.data('prevPage', data.prev_page_url ? data.current_page - 1 : '');
            self.data('nextPage', data.next_page_url ? data.current_page + 1 : '');
            self.data('currentPage', data.current_page);

            data.data.map(function (v) {
                var item = $('.page-useds .empty-components.card-used').first().clone();

                item.removeClass('hidden');
                item.find('.t-image').attr('src', v.thumb).attr('alt', v.title);
                item.find('.t-category').html(v.used_category ? v.used_category.name : '');
                item.find('.t-name').html(v.name);
                item.find('.t-url').attr('href', v.url).attr('alt', v.title).attr('target', v.target); //TODO _self/_blank

                $('.page-useds .grid').append(item);
            });

            self.removeClass('loading');

            updateUseds();
        },
        error: function (data) {
            Toastify({
                text: 'Houve um erro, tente novamente.',
                duration: 1500,
                newWindow: true,
                close: true,
                gravity: 'top',
                position: 'center',
                stopOnFocus: true,
                style: {
                    background: 'linear-gradient(135deg, #FF9441, #F36F21)',
                },
                onClick: function () {},
            }).showToast();

            self.removeClass('loading');
        },
    });
}

function initialize() {
    $('.page-useds .filter .btn').on('click', function () {
        getListUseds();
    });

    $('.page-useds .nav-page .btn-prev').on('click', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();

        let prevPage = componentData.data('prevPage');
        if (prevPage) {
            getListUseds(prevPage);
        }

        return false;
    });

    $('.page-useds .nav-page .btn-next').on('click', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();

        let nextPage = componentData.data('nextPage');

        if (nextPage) {
            getListUseds(nextPage);
        }

        return false;
    });

    //Initialize
    updateUseds();
}

initialize();
